/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { ChatProviderType, ChatType } from '../../components/chat-list-section/chat-row/typings';
import Avatar from '@mui/material/Avatar';
import { getColorFromIdentifier, getColorFromPhone } from '../../utils/colors';
import { CSSProperties, useMemo } from 'react';
import { chatRowAvatarSize, chatRowAvatarStyles } from '../../constants';
import BroadcastGroupIcon from '../../../../../shared/icons/icons-revamp/user_group';
import { WithProviderIcon } from './WithProviderIcon';

export function ChatProfileAvatar({
  chatType,
  phoneNumber = '',
  name = '',
  profilePicture,
  styles,
  size = chatRowAvatarSize,
  customSize = false,
  providerType,
  showProviderIcon = false,
}: {
  chatType?: ChatType;
  phoneNumber?: string;
  name?: string;
  profilePicture?: string;
  styles?: CSSProperties;
  size?: number;
  customSize?: boolean;
  providerType?: ChatProviderType | null;
  showProviderIcon?: boolean;
}) {
  const displayName = useMemo(
    () =>
      (name ?? phoneNumber ?? '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .trim()
        ?.charAt(0)
        .toUpperCase() ?? '0',
    [name, phoneNumber]
  );

  if (!chatType) {
    return null;
  }

  if (chatType === ChatType.GROUP || chatType === ChatType.WA_GROUP) {
    return (
      <WithProviderIcon providerType={providerType || null} showProviderIcon={showProviderIcon}>
        <Avatar
          style={styles}
          css={css`
            background-color: #3d906d33;
            width: ${size}px;
            height: ${size}px;
          `}
        >
          <BroadcastGroupIcon />
        </Avatar>
      </WithProviderIcon>
    );
  }

  const color =
    providerType === ChatProviderType.WHATSAPP || !providerType
      ? getColorFromPhone({ phone: phoneNumber, chatType, name })
      : getColorFromIdentifier({ identifier: name || phoneNumber, chatType });

  if (profilePicture) {
    return (
      <WithProviderIcon providerType={providerType || null} showProviderIcon={showProviderIcon}>
        <Avatar
          style={styles}
          src={profilePicture}
          alt={displayName}
          css={css(
            chatRowAvatarStyles,
            css`
              background: ${color}32;
              color: ${color};
              font-size: 1rem;
              font-weight: 600;
              text-transform: capitalize;
              width: ${size}px;
              height: ${size}px;
            `
          )}
        />
      </WithProviderIcon>
    );
  }
  if (customSize) {
    return (
      <div
        css={css(
          chatRowAvatarStyles,
          css`
            background: ${color}32;
            color: ${color};
            font-weight: 600;
            text-transform: capitalize;
            width: ${size}px;
            height: ${size}px;
            font-size: 12px;
          `
        )}
        style={styles}
      >
        {displayName}
      </div>
    );
  }
  return (
    <WithProviderIcon providerType={providerType || null} showProviderIcon={showProviderIcon}>
      <div
        css={css(
          chatRowAvatarStyles,
          css`
            background: ${color}32;
            color: ${color};
            font-weight: 600;
            text-transform: capitalize;
          `
        )}
        style={styles}
      >
        {displayName}
      </div>
    </WithProviderIcon>
  );
}
